export const dealerKeys = {
  all: ['dealers'] as const,
  lists: () => [...dealerKeys.all, 'list'] as const,
  list: (companyId: string) => [...dealerKeys.lists(), companyId] as const,
  details: () => [...dealerKeys.all, 'detail'] as const,
  detail: (id: string) => [...dealerKeys.details(), id] as const,
  byCompany: (companyId: string) => ['dealers', 'byCompany', companyId] as const,
}
